import http from "../../helpers/http";

import {
  FETCH_HELP_AND_RECOURCES_CONTENT_SUCCESS,
  FETCH_HELP_AND_RECOURCES_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("help-and-resources")
    .then(({ data }) => {
      dispatch({
        type: FETCH_HELP_AND_RECOURCES_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_HELP_AND_RECOURCES_CONTENT_FAILED,
        payload: error
      });
    });
};
